// src/data/data.js
const selectIconRequire = require.context(
    '@/assets/images/active/snail/yayaLand/question/icon',
    false,
    /\.png$/
);

export const rawQuestions = [{
        id: 1,
        title: "以下哪个场景，是你童年放学后的“第一作案现场”？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_01.png'),
        options: [
            { text: "乌烟瘴气的黑网吧", icon: require('@/assets/images/active/snail/yayaLand/question/01.png'), cert: "黑网吧连续通宵72小时", scores: { S: 2, C: 8, V: 10, D: 5 } },
            { text: "门口大爷的小卖部", icon: require('@/assets/images/active/snail/yayaLand/question/02.png'), cert: "捏碎干脆面只为偷集水浒卡", scores: { S: 10, C: 5, V: 0, D: 5 } },
            { text: "藏在地下室的电玩城", icon: require('@/assets/images/active/snail/yayaLand/question/03.png'), cert: "摇杆搓出火星子被老板拔电源", scores: { S: 8, C: 8, V: 8, D: 8 } },
            { text: "还没关灯的空教室", icon: require('@/assets/images/active/snail/yayaLand/question/04.png'), cert: "用圆珠笔疯狂抄写同学秘籍", scores: { S: 0, C: 0, V: 0, D: 0 } }
        ]
    },
    {
        id: 2,
        title: "当你听到以下哪句话时，童年的DNA动得最剧烈？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_02.png'),
        options: [
            { text: "你QQ号被盗了", icon: require('@/assets/images/active/snail/yayaLand/question/05.png'), cert: "痛失非主流火星文网名", scores: { S: 5, C: 5, V: 10, D: 8 } },
            { text: "放学别走，操场见", icon: require('@/assets/images/active/snail/yayaLand/question/06.png'), cert: "发起毫无杀伤力的操场决战", scores: { S: 10, C: 10, V: 0, D: 10 } },
            { text: "你妈拿着衣架过来了", icon: require('@/assets/images/active/snail/yayaLand/question/07.png'), cert: "练就无敌铁布衫但依然被揍", scores: { S: 0, C: 10, V: 2, D: 0 } },
            { text: "明天交背诵默写全文", icon: require('@/assets/images/active/snail/yayaLand/question/08.png'), cert: "梦想拥有哆啦A梦的记忆面包", scores: { S: 0, C: 0, V: 2, D: 0 } }
        ]
    },
    {
        id: 3,
        title: "电脑课上，老师一转头你就在干嘛？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_03.png'),
        options: [
            { text: "狂点鼠标玩4399", icon: require('@/assets/images/active/snail/yayaLand/question/09.png'), cert: "练就光速Alt+Tab切屏神功", scores: { S: 5, C: 8, V: 10, D: 8 } },
            { text: "往QQ群里狂发闪动炫彩表情包", icon: require('@/assets/images/active/snail/yayaLand/question/10.png'), cert: "在QQ群制造高强度视觉污染", scores: { S: 10, C: 5, V: 10, D: 5 } },
            { text: "偷偷拔掉旁边同学的主机电源", icon: require('@/assets/images/active/snail/yayaLand/question/11.png'), cert: "成为机房断电带恶人", scores: { S: 2, C: 10, V: 2, D: 2 } },
            { text: "盯着Windows自带的迷宫屏保发呆", icon: require('@/assets/images/active/snail/yayaLand/question/12.png'), cert: "在电脑课上试图领悟宇宙真理", scores: { S: 0, C: 0, V: 5, D: 10 } }
        ]
    },
    {
        id: 4,
        title: "你抽屉里藏得最深、最怕被发现的“违禁品”是什么？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_04.png'),
        options: [
            { text: "被大卸八块的电子宠物机", icon: require('@/assets/images/active/snail/yayaLand/question/13.png'), cert: "物理超度电子宠物并拆解电池", scores: { S: 0, C: 10, V: 8, D: 5 } },
            { text: "满是烟味和非主流大头贴的密码本", icon: require('@/assets/images/active/snail/yayaLand/question/14.png'), cert: "上传45张辣眼睛大头贴", scores: { S: 0, C: 10, V: 8, D: 5 } },
            { text: "没写完的玛丽苏小说", icon: require('@/assets/images/active/snail/yayaLand/question/15.png'), cert: "脑补自己是暗夜吸血鬼皇族", scores: { S: 2, C: 0, V: 2, D: 10 } },
            { text: "考了20分但完美伪造了家长签名的试卷", icon: require('@/assets/images/active/snail/yayaLand/question/16.png'), cert: "模仿家长签名达到以假乱真", scores: { S: 5, C: 8, V: 0, D: 2 } }
        ]
    },
    {
        id: 5,
        title: "如果在乐园里发现童年零食，你的硬核吃法是？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_05.png'),
        options: [
            { text: "跳跳糖全倒在舌头上", icon: require('@/assets/images/active/snail/yayaLand/question/17.png'), cert: "把口腔变成爆破施工现场", scores: { S: 10, C: 8, V: 0, D: 5 } },
            { text: "叼着辣条装深沉", icon: require('@/assets/images/active/snail/yayaLand/question/18.png'), cert: "叼着辣条装作历经沧桑的大佬", scores: { S: 8, C: 2, V: 0, D: 10 } },
            { text: "抠搜搜地榨干最后一滴AD钙奶", icon: require('@/assets/images/active/snail/yayaLand/question/19.png'), cert: "抠搜搜地榨干最后一滴奶", scores: { S: 0, C: 0, V: 0, D: 0 } },
            { text: "趁别人不注意，往别人饮料里加粉笔灰", icon: require('@/assets/images/active/snail/yayaLand/question/20.png'), cert: "调配生化武器级致死量毒药", scores: { S: 5, C: 10, V: 0, D: 2 } }
        ]
    },
    {
        id: 6,
        title: "电视机突然满屏雪花没信号，你的第一反应是？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_06.png'),
        options: [
            { text: "对着侧面猛拍三下", icon: require('@/assets/images/active/snail/yayaLand/question/21.png'), cert: "试图用暴力给家用电器开光", scores: { S: 5, C: 10, V: 2, D: 2 } },
            { text: "转动天线充当信号接收器", icon: require('@/assets/images/active/snail/yayaLand/question/22.png'), cert: "自愿化身人工肉体信号塔", scores: { S: 8, C: 5, V: 5, D: 8 } },
            { text: "以为贞子要爬出来，用被子蒙头", icon: require('@/assets/images/active/snail/yayaLand/question/23.png'), cert: "脑补恐怖片情节把自己吓尿", scores: { S: 0, C: 0, V: 0, D: 10 } },
            { text: "假装电视坏了偷看金鹰卡通", icon: require('@/assets/images/active/snail/yayaLand/question/24.png'), cert: "偷看动漫并完美伪造案发现场", scores: { S: 2, C: 5, V: 8, D: 5 } }
        ]
    },
    {
        id: 7,
        title: "以下哪个画面让你感觉“童年被毁”？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_07.png'),
        options: [
            { text: "皮套里是抠脚大汉", icon: require('@/assets/images/active/snail/yayaLand/question/25.png'), cert: "试图当街扒开路人的皮套", scores: { S: 5, C: 8, V: 5, D: 10 } },
            { text: "爸妈把卡带送给亲戚小孩", icon: require('@/assets/images/active/snail/yayaLand/question/26.png'), cert: "在亲戚面前当场黑化变异", scores: { S: 0, C: 10, V: 10, D: 2 } },
            { text: "我不是被选召的孩子", icon: require('@/assets/images/active/snail/yayaLand/question/27.png'), cert: "认清自己只是底层NPC的残酷现实", scores: { S: 2, C: 2, V: 5, D: 10 } },
            { text: "不转不是中国人全是骗局", icon: require('@/assets/images/active/snail/yayaLand/question/28.png'), cert: "意识到当年是个被钓鱼的傻子", scores: { S: 10, C: 0, V: 10, D: 0 } }
        ]
    },
    {
        id: 8,
        title: "童年和好朋友闹掰，你采取过的最极端报复是？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_08.png'),
        options: [
            { text: "空间发非主流伤感说说", icon: require('@/assets/images/active/snail/yayaLand/question/29.png'), cert: "在QQ空间45度角仰望天空流泪", scores: { S: 10, C: 2, V: 10, D: 8 } },
            { text: "画三八线，拿圆规扎人", icon: require('@/assets/images/active/snail/yayaLand/question/30.png'), cert: "物理切割同桌领土并武装防卫", scores: { S: 5, C: 10, V: 0, D: 5 } },
            { text: "内心排演复仇大戏", icon: require('@/assets/images/active/snail/yayaLand/question/31.png'), cert: "脑内疯狂排演八百次绝交剧本", scores: { S: 0, C: 0, V: 0, D: 10 } },
            { text: "登账号删装备", icon: require('@/assets/images/active/snail/yayaLand/question/32.png'), cert: "执行惨无人道的赛博财产清零", scores: { S: 0, C: 10, V: 10, D: 2 } }
        ]
    },
    {
        id: 9,
        title: "童年坚信不疑的谣言？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_09.png'),
        options: [
            { text: "吃西瓜会肚子长藤", icon: require('@/assets/images/active/snail/yayaLand/question/33.png'), cert: "每天提心吊胆怕自己变成植物人", scores: { S: 2, C: 0, V: 0, D: 8 } },
            { text: "卡Bug能爆神装", icon: require('@/assets/images/active/snail/yayaLand/question/34.png'), cert: "对着空气平A一万次试图卡穿模", scores: { S: 8, C: 8, V: 10, D: 5 } },
            { text: "跑得快妈妈拖鞋追不上", icon: require('@/assets/images/active/snail/yayaLand/question/35.png'), cert: "领悟了风骚走位但依然被物理制裁", scores: { S: 10, C: 5, V: 0, D: 5 } },
            { text: "牵手就会怀孕", icon: require('@/assets/images/active/snail/yayaLand/question/36.png'), cert: "以为自己看一眼异性就当妈/爹了", scores: { S: 0, C: 0, V: 2, D: 10 } }
        ]
    },
    {
        id: 10,
        title: "给童年的门票，第一件事干嘛？",
        titleImg: require('@/assets/images/active/snail/yayaLand/question/title_10.png'),
        options: [
            { text: "删掉当年非主流照片", icon: require('@/assets/images/active/snail/yayaLand/question/37.png'), cert: "试图强行抹杀自己的数字黑历史", scores: { S: 5, C: 8, V: 10, D: 5 } },
            { text: "告诉自己别长大", icon: require('@/assets/images/active/snail/yayaLand/question/38.png'), cert: "试图给过去的自己洗脑防止长大", scores: { S: 2, C: 2, V: 5, D: 10 } },
            { text: "记下双色球号码", icon: require('@/assets/images/active/snail/yayaLand/question/39.png'), cert: "满脑子都是搞钱的世俗欲望", scores: { S: 10, C: 5, V: 5, D: 0 } },
            { text: "去牵同桌的手", icon: require('@/assets/images/active/snail/yayaLand/question/40.png'), cert: "试图强行修复自己母胎单身的bug", scores: { S: 0, C: 5, V: 0, D: 10 } }
        ]
    }
];

export const questions = rawQuestions.map((question, questionIndex) => {
    return {
        ...question,
        options: question.options.map((option, optionIndex) => {
            const iconIndex = questionIndex * 4 + optionIndex + 1;

            return {
                ...option,
                selectIcon: selectIconRequire(`./${iconIndex}.png`)
            };
        })
    };
});

export const identities = {
    "ECVD": { name: "【2004年互联网遗民】", desc: "赛博世界最吵闹的非主流。你那布满火星文的QQ空间，比现在的核废料还要辣眼睛。建议把当年的说说打印出来贴门上辟邪。" },
    "ECVP": { name: "【祖安初代暴躁钢琴家】", desc: "没有感情的喷人机器，以键盘为大刀的破坏王。小时候你砸网吧键盘，长大了你在工作群里阴阳怪气，真有你的。" },
    "ECRD": { name: "【小区猴王兼拆迁办主任】", desc: "拿着树枝当宝剑，领着一帮小弟在小区里四处征战的破坏神。你路过的地方狗都要挨两巴掌，能活到现在全靠家长求情。" },
    "ECRP": { name: "【街机厅在逃盲流子】", desc: "逃课打街机，擅长白嫖游戏币，早就被老板拉黑的街头霸王。你的童年就是在躲避亲妈衣架和老板扫帚的极致走位中度过的。" },
    "EOVD": { name: "【QQ群活跃龙王】", desc: "每天按时打卡发“群主女装”，活跃于各个赛博群聊的显眼包。看似人脉极广，实则是没人理就浑身难受的赛博空巢青年。" },
    "EOVP": { name: "【无情的赛博电子榨菜】", desc: "喜欢跟风转发，群里最爱发“+1”和点赞表情包的复读机。毫无主见，你的脑电波和Windows默认屏保一样规律且无聊。" },
    "EORD": { name: "【戏精广播体操领操员】", desc: "班级里最爱出风头，动作最夸张，自诩为太阳之子的课代表。其实大家当时都在背后偷偷笑你，只有你沉浸在自己的光芒中。" },
    "EORP": { name: "【小卖部散财童子】", desc: "请全班吃辣条只为换取虚假友谊，毫无灵魂的ATM机。小时候用零食买朋友，长大了用工资买尊严，纯纯的现实主义大冤种。" },
    "ICVD": { name: "【暗黑系贴吧潜水刺客】", desc: "默默收藏黑历史，偷记别人密码，自以为是暗影刺客的赛博孤狼。现实中唯唯诺诺，网络上你暗中记仇，是个危险的家伙。" },
    "ICVP": { name: "【黑网吧角落人形真菌】", desc: "连续通宵不洗澡，只会默默刷怪的无情机器。你和网吧角落那台漏电的电脑主机已经融为一体了，你没有童年，只有等级。" },
    "ICRD": { name: "【野生科学怪人】", desc: "物理毁灭者！手撕小霸王，肢解电子宠物。别人玩游戏，你是直接从物理层面消灭游戏，至今没有家电敢在你的注视下正常运作。" },
    "ICRP": { name: "【后排无产阶级睡神】", desc: "上课睡觉，下课尿尿，用圆规把课桌刻得稀巴烂的摸鱼大师。你把混沌的精力全用来搞小破坏了，主打一个啥也不干但也没闲着。" },
    "IOVD": { name: "【重度赛博纸性恋阿宅】", desc: "对着屏幕叫老婆/老公，QQ宠物死了还要写千字祭文。你的精神世界极度丰富且离谱，现实世界却连异性的手都没碰过。" },
    "IOVP": { name: "【4399无情单机王】", desc: "不和任何人联机，只玩黄金矿工，机械般点击鼠标的赛博苦工。从不追求刺激，只追求稳定，你的人生就像一盘扫雷，处处小心翼翼。" },
    "IORD": { name: "【隐形龙傲天小说家】", desc: "表面上乖巧做题，实则在草稿纸上狂写了几十万字的玛丽苏/修仙小说。坚信自己体内封印着超能力，目前看来，只封印了你的智商。" },
    "IORP": { name: "【只会埋头读书的书呆子】", desc: "童年只有《五年高考三年模拟》，没有青春，无聊到让狗看了都打哈欠的做题家。丫丫乐园对你来说太刺激了，建议回去接着做几套卷子压压惊。" }
};


// WEBPACK FOOTER //
// ./src/pages/snail/yayaLand/data.js